import { select, call, put } from 'redux-saga/effects';

import { entityIdSelector } from '../../selectors/user';
import UserClient from '../../api/UserClient';
import { messagesShow } from '../../redux/messages/actions';
import { getPaymentDetails } from '../../redux/user/actions';
import { clearAdyenSession } from '../../redux/app/actions';

/**
 * Sessions-flow setup-intent synchronization (ISJ-8831).
 *
 * Called after the Adyen SDK fires `onPaymentCompleted` on the shared
 * AdyenCheckout instance. Confirms the final status with BE, shows a
 * success/failure toast, refreshes the user's payment details, then clears
 * the session and closes the modal.
 *
 * Reference: docs/superpowers/specs/2026-05-18-isj-8831-fo-adyen-google-pay-design.md §5
 */
export default function* synchronizeAdyenSetupIntent({ payload: { setupIntentId, toggleAdyenModal } }) {
    const entityId = yield select(entityIdSelector);
    try {
        const intent = yield call(UserClient.synchronizeSetupIntent, entityId, setupIntentId);
        if (intent && intent.status === 'SUCCEEDED') {
            yield put(messagesShow('PaymentSuccess', 'success'));
            yield put(getPaymentDetails());
        } else {
            yield put(messagesShow('PaymentError', 'error'));
        }
    } catch (error) {
        console.error('synchronizeAdyenSetupIntent', error);
        yield put(messagesShow('PaymentError', 'error'));
    } finally {
        yield put(clearAdyenSession());
        if (typeof toggleAdyenModal === 'function') {
            toggleAdyenModal();
        }
    }
}
